import { McpTool } from './mcpTypes';

/**
 * Parses a `spec.definition` snapshot into a list of tools. Accepts either a
 * bare array of tools or an object with a `tools` array, and tolerates JSON
 * provided as a string (e.g. resolved from a `$text` placeholder).
 */
export const parseStaticTools = (definition: unknown): McpTool[] | undefined => {
  if (definition === undefined || definition === null) {
    return undefined;
  }

  let value: unknown = definition;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch {
      return undefined;
    }
  }

  const tools = Array.isArray(value) ? value : (value as { tools?: unknown } | undefined)?.tools;

  if (!Array.isArray(tools)) {
    return undefined;
  }

  return tools.filter(
    (tool): tool is McpTool =>
      typeof tool === 'object' && tool !== null && typeof (tool as McpTool).name === 'string',
  );
};
